// extracted by mini-css-extract-plugin
export default {"totalPrice":"sovag","totalPriceRow":"iSa8j"};